/* eslint no-useless-escape: "off" */
// prettier-ignore
const encodings = {
    '\+': "%2B",
    '\!': "%21",
    '\"': "%22",
    '\#': "%23",
    '\$': "%24",
    '\&': "%26",
    '\'': "%27",
    '\(': "%28",
    '\)': "%29",
    '\*': "%2A",
    '\,': "%2C",
    '\:': "%3A",
    '\;': "%3B",
    '\=': "%3D",
    '\?': "%3F",
    '\@': "%40",
};
function s3URLEncode(filename) {
    // prettier-ignore
    return filename.replace(/([+!"#$&'()*+,:;=?@])/img, match => encodings[match]);
}

export { s3URLEncode };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiczMtdXRpbHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9zMy11dGlscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQgbm8tdXNlbGVzcy1lc2NhcGU6IFwib2ZmXCIgKi9cbi8vIHByZXR0aWVyLWlnbm9yZVxuY29uc3QgZW5jb2RpbmdzOiBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+ID0ge1xuICAnXFwrJzogXCIlMkJcIixcbiAgJ1xcISc6IFwiJTIxXCIsXG4gICdcXFwiJzogXCIlMjJcIixcbiAgJ1xcIyc6IFwiJTIzXCIsXG4gICdcXCQnOiBcIiUyNFwiLFxuICAnXFwmJzogXCIlMjZcIixcbiAgJ1xcJyc6IFwiJTI3XCIsXG4gICdcXCgnOiBcIiUyOFwiLFxuICAnXFwpJzogXCIlMjlcIixcbiAgJ1xcKic6IFwiJTJBXCIsXG4gICdcXCwnOiBcIiUyQ1wiLFxuICAnXFw6JzogXCIlM0FcIixcbiAgJ1xcOyc6IFwiJTNCXCIsXG4gICdcXD0nOiBcIiUzRFwiLFxuICAnXFw/JzogXCIlM0ZcIixcbiAgJ1xcQCc6IFwiJTQwXCIsXG59O1xuXG5leHBvcnQgZnVuY3Rpb24gczNVUkxFbmNvZGUoZmlsZW5hbWU6IHN0cmluZyk6IHN0cmluZyB7XG4gIC8vIHByZXR0aWVyLWlnbm9yZVxuICByZXR1cm4gZmlsZW5hbWUucmVwbGFjZSgvKFsrIVwiIyQmJygpKissOjs9P0BdKS9pbWcsIG1hdGNoID0+IGVuY29kaW5nc1ttYXRjaF0pXG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtBQUNBLE1BQU0sU0FBUyxHQUEyQjtBQUN4QyxJQUFBLElBQUksRUFBRSxLQUFLO0FBQ1gsSUFBQSxJQUFJLEVBQUUsS0FBSztBQUNYLElBQUEsSUFBSSxFQUFFLEtBQUs7QUFDWCxJQUFBLElBQUksRUFBRSxLQUFLO0FBQ1gsSUFBQSxJQUFJLEVBQUUsS0FBSztBQUNYLElBQUEsSUFBSSxFQUFFLEtBQUs7QUFDWCxJQUFBLElBQUksRUFBRSxLQUFLO0FBQ1gsSUFBQSxJQUFJLEVBQUUsS0FBSztBQUNYLElBQUEsSUFBSSxFQUFFLEtBQUs7QUFDWCxJQUFBLElBQUksRUFBRSxLQUFLO0FBQ1gsSUFBQSxJQUFJLEVBQUUsS0FBSztBQUNYLElBQUEsSUFBSSxFQUFFLEtBQUs7QUFDWCxJQUFBLElBQUksRUFBRSxLQUFLO0FBQ1gsSUFBQSxJQUFJLEVBQUUsS0FBSztBQUNYLElBQUEsSUFBSSxFQUFFLEtBQUs7QUFDWCxJQUFBLElBQUksRUFBRSxLQUFLO0NBQ1o7QUFFSyxTQUFVLFdBQVcsQ0FBQyxRQUFnQixFQUFBOztBQUUxQyxJQUFBLE9BQU8sUUFBUSxDQUFDLE9BQU8sQ0FBQywwQkFBMEIsRUFBRSxLQUFLLElBQUksU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ2hGOzs7OyJ9
